import React from 'react'
import { Box, Typography } from '@mui/material'
import Videos from './Videos'
import { fatchFromApi } from '../utils/fatchFromApi'
import { useParams } from 'react-router-dom'

const SearchFeed = () => {
  const [videos, setVideos] = React.useState([]);
  const {searchTerm} = useParams();

  React.useEffect(() => {
    fatchFromApi(`search?part=snippet&q=${searchTerm}`).then((data) => setVideos(data.items))
  },[searchTerm])

  return (
    <Box p={2} sx={{overflowY: 'auto', height: '90vh', flex: 2}}>
        
        <Typography variant='h4' fontWeight='bold' mb={2} sx={{color: 'white'}}>
          {searchTerm} <span style={{color:'#f31503'}}>{searchTerm}</span> videos
        </Typography>
        
        <Videos videos={videos} />
  
      </Box>
  )
}

export default SearchFeed